import cx from 'classnames';
import React, { ReactNode } from 'react';

import './page-content-title.scss';

interface Props {
    link?: ReactNode;
    mix?: string;
    subTitle?: ReactNode;
    title?: ReactNode;
}

const PageContentTitle = ({ title, subTitle, link, mix }: Props) => {
    return (
        <div className={cx('page-content-title', mix)}>
            <div className="page-content-title__title">{title}</div>
            {subTitle && <div className="page-content-title__sub-title">{subTitle}</div>}
            {link && <div className="page-content-title__link">{link}</div>}
        </div>
    );
};

export default PageContentTitle;
